
export { default as EditNumber } from "./lib/EditNumber/editNumber"